import { FC, PropsWithChildren, useEffect, useReducer } from "react";
import AppContext, { AppActionTypes, appReducer } from "@/core/context/AppContext.ts";
import { useUserQuery } from "@/core/api/hooks/user.ts";
import { ApplicationError } from "@/core/api/model/error.ts";

export const AppProvider: FC<PropsWithChildren> = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, {
        user: null,
        error: ApplicationError.NONE,
    });

    const { data: user, isError: error } = useUserQuery();

    useEffect(() => {
        if (error) {
            dispatch({ type: AppActionTypes.SET_ERROR, payload: ApplicationError.UNKNOWN });
        }
        if (user) {
            dispatch({ type: AppActionTypes.SET_USER, payload: user });
        }
    }, [user, error]);

    return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};
